import gql from 'graphql-tag';

export const FONT_FACE_DECLARATIONS_QUERY = gql`
  query FontFaceDeclarationsQuery($faceIds: [Int!]) {
    fontFaces(ids: $faceIds) {
      id
      cssFontFaceDeclaration
    }
  }
`;
